/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Import_Failed_ToastInputs */

const en_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error - Media import failed`)
};

const fr_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur - Echec de l'importation du media`)
};

const de_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler – Medienimport fehlgeschlagen`)
};

const it_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore - Importazione del supporto non riuscita`)
};

const ru_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка - Не удалось импортировать медиафайлы`)
};

const es_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: Error en la importación de medios`)
};

const zh_cn2_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误 - 媒体导入失败`)
};

const ja_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー - メディアのインポートに失敗しました`)
};

const hi_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि - मीडिया आयात विफल रहा`)
};

const pt_pt2_load_project_file_media_import_failed_toast = /** @type {(inputs: Load_Project_File_Media_Import_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro - Falha na importação de mídia`)
};

/**
* | output |
* | --- |
* | "Error - Media import failed" |
*
* @param {Load_Project_File_Media_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_import_failed_toast = /** @type {((inputs?: Load_Project_File_Media_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_media_import_failed_toast(inputs)
	if (locale === "de") return de_load_project_file_media_import_failed_toast(inputs)
	if (locale === "it") return it_load_project_file_media_import_failed_toast(inputs)
	if (locale === "ru") return ru_load_project_file_media_import_failed_toast(inputs)
	if (locale === "es") return es_load_project_file_media_import_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_media_import_failed_toast(inputs)
	if (locale === "ja") return ja_load_project_file_media_import_failed_toast(inputs)
	if (locale === "hi") return hi_load_project_file_media_import_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_media_import_failed_toast(inputs)
	return en_load_project_file_media_import_failed_toast(inputs)
});